import Vue from 'vue';
import Router from 'vue-router';
// import jsCookie from 'js-cookie';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes: [
        // 登陆页
        {
            path: '/',
            redirect: '/account/login'
        },
        {
            path: '/account/login',
            name: 'login@account',
            component: () => import('@/views/index/views/AccountPage/AccountLogin/AccountLogin')
        },
        {
            path: '/account',
            component: () =>
                import('@/views/index/views/AccountPage/AccountPage'),
            children: [
                // {
                //     path: 'login',
                //     name: 'login@account',
                //     meta: { name: '登录', isFullScreen: true },
                //     component: () =>
                //         import('@/views/index/views/AccountPage/AccountLogin/AccountLogin')
                // },
                {
                    path: 'register',
                    name: 'register@account',
                    meta: { name: '注册', isFullScreen: true },
                    component: () =>
                        import('@/views/index/views/AccountPage/AccountRegister/AccountRegister')
                },
                {
                    path: 'find',
                    name: 'find@account',
                    meta: { name: '找回密码', isFullScreen: true },
                    component: () =>
                        import('@/views/index/views/AccountPage/AccountFind/AccountFind')
                }
            ]
        },
        // 首页
        {
            path: '/index',
            name: 'index@index',
            meta: { name: '首页', hideSidebar: true },
            component: () =>
                import('@/views/index/views/Index/Index')
        },
        // 注册认证
        {
            path: '/register',
            component: () =>
                import('@/views/index/views/RegisterPage/RegisterPage'),
            children: [
                // 基本信息
                {
                    path: 'basic',
                    name: 'basic@register',
                    meta: { isFullScreen: true },
                    component: () =>
                        import('@/views/index/views/RegisterPage/RegisterBasic/RegisterBasic')
                },
                // 基本资料
                {
                    path: 'teach',
                    name: 'teach@register',
                    meta: { isFullScreen: true },
                    component: () =>
                        import('@/views/index/views/RegisterPage/RegisterTeach/RegisterTeach')
                },
                // 证件认证 + 认证成功
                {
                    path: 'certificate',
                    name: 'certificate@register',
                    meta: { isFullScreen: true },
                    component: () =>
                        import('@/views/index/views/RegisterPage/RegisterCertificate/RegisterCertificate')
                }
            ]
        },
          // 追踪测试报告
        {
              path: '/myStudent/test/report',
              name: 'test@report',
              meta: {
                  name: '追踪测试报告',
                  hideSidebar: true
              },
              component: () =>
                  import('@/views/index/views/AuditionCoursePlan/TestReport')
          },
        // 我的课程-我的课表. 不在course下设置children是因为各个结构没有共享页面元素，没必要专门建立一个course.vue组件包容 & 写胶水代码。
        {
            path: '/course/schedule',
            name: 'schedule@course',
            meta: { name: '我的课表' },
            component: () =>
                import('@/views/index/views/CourseSchedule/CourseSchedule')
        },
        {
            path: '/create-coursreware',
            name: 'createCourseware@course',
            meta: { name: '创建课件', hideSidebar: true },
            component: () =>
                import('@/views/index/views/CreateCourseware/Index')
        },
        {
            path: '/couse/cancelRecord',
            name: 'schedule@CancelRecord',
            meta: {
                name: '取消记录'
            },
            component: () => import('@/views/index/views/CancelRecord/CancelRecord')
        },
        // 我的课程-我的学生-学生列表
        {
            path: '/course/student',
            name: 'student@course',
            meta: { name: '我的学生' },
            component: () =>
                import('@/views/index/views/StudentList/StudentList')
        },
        // 新流程在线备课
        {
            path: '/course/online',
            component: () =>
                import('@/views/index/views/CourseOnline/CourseOnline'),
            children: [
                {
                    path: 'handout',
                    name: 'onlineHandout@course',
                    meta: { name: '在线备课', hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/CourseOnline/CourseOnlineHandout/CourseOnlineHandout')
                },
                {
                    path: 'courseware',
                    name: 'onlineCourseware@course',
                    meta: { name: '在线备课', hideSidebar: true, keepAlive: true },
                    component: () =>
                        import('@/views/index/views/CreateCourseware/Index')
                },
                            // 新增课件页面
                {
                    path: '/add-coursreware',
                    name: 'addCourseware@course',
                    meta: { name: '新增课件', hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/CourseOnline/AddCourseware/AddCourseware')
                },
                {
                    path: 'exercise',
                    name: 'onlineExercise@course',
                    meta: { name: '添加题目', hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/CourseOnline/CourseOnlineExercise/CourseOnlineExercise')
                }
            ]
        },
        // 我的课程-课程历史
        {
            path: '/course/history',
            name: 'history@course',
            meta: { name: '课程历史' },
            component: () =>
                import('@/views/index/views/CourseHistory/CourseHistory')
        },
        // 我的课程-课程历史-视频回放
        {
            path: '/recordVideo',
            name: 'history@video',
            meta: { name: '视频回放', hideSidebar: true },
            component: () =>
                import('@/views/index/views/VideoView/VideoView')
        },
        // 我的课程-课程历史-课程日志(v2.10重构)
        {
            path: '/courseLog',
            name: 'history@courseLog',
            meta: { name: '课程日志', hideSidebar: true },
            component: () =>
                import('@/views/index/components/CourseLog/index')
        },
        // 我的课程-课程历史-课程日志三端适配路由(v3.5.1日志优化)
        {
            path: '/mobileLog',
            name: 'history@mobileLog',
            meta: { name: '课程日志', hideSidebar: true, hideHeader: true, hideFooter: true, mobile: true },
            component: () =>
                import('@/views/index/components/CourseLog/index')
        },
        // 我的课程-课时设置
        {
            path: '/course/setting',
            name: 'setting@course',
            meta: { name: '上课时间-精确设置' },
            component: () =>
                import('@/views/index/views/TimeSetting/TimeSetting')
        },
        // 我的课程-课时设置
        {
            path: '/course/settingWeekly',
            name: 'setting@courseWeekly',
            meta: { name: '上课时间-批量设置' },
            component: () =>
                import('@/views/index/views/TimeSettingWeekly/TimeSettingWeekly')
        },
        // 我的课程-测评与考试-测评列表
        {
            path: '/course/evaluation',
            name: 'evaluation@course',
            meta: { name: '测评列表' },
            component: () =>
                import('@/views/index/views/EvaluationList/EvaluationList')
        },
        // 胶囊测评
        {
            path: '/course/evaluation/capsule',
            name: 'evaluation@capsule',
            meta: { name: '胶囊测评' },
            component: () =>
                import('@/views/index/views/EvaluationListNew/NewEvaluationList')
        },
        // 用户中心模块
        {
            path: '/user',
            component: () =>
                import('@/views/index/views/UserPage/UserPage'),
            children: [
                // 我的学费
                // {
                //     path: 'record/tuition',
                //     name: 'tuitionRecord@user',
                //     meta: { hideSidebar: true },
                //     component: () =>
                //         import('@/views/index/views/UserPage/UserRecordTuition/UserRecordTuition')
                // },
                // 我的课时
                {
                    path: 'record/period',
                    name: 'periodRecord@user',
                    meta: { hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/UserPage/UserRecordPeriod/UserRecordPeriod')
                },
                // 我的豆豆
                {
                    path: 'record/bean',
                    name: 'beanRecord@user',
                    meta: { hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/UserPage/UserRecordBean/UserRecordBean')
                },
                // 个人信息
                {
                    path: 'info/basic',
                    name: 'basicInfo@user',
                    meta: { hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/UserPage/UserInfoBasic/UserInfoBasic')
                },
                // 教学信息
                {
                    path: 'info/teach',
                    name: 'teachInfo@user',
                    meta: { hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/UserPage/UserInfoTeach/UserInfoTeach')
                },
                // 我的等级
                {
                    path: 'info/level',
                    name: 'levelInfo@user',
                    meta: { hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/UserPage/UserInfoLevel/UserInfoLevel')
                },
                // 合同信息
                {
                    path: 'info/contract',
                    name: 'contractInfo@user',
                    meta: { hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/UserPage/UserInfoContract/UserInfoContract')
                },
                // 绑定手机
                {
                    path: 'account/phone',
                    name: 'phoneAccount@user',
                    meta: { hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/UserPage/UserAccountPhone/UserAccountPhone')
                },
                // 修改绑定手机
                {
                    path: 'account/phoneModification',
                    name: 'phoneAccountModification@user',
                    meta: { hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/UserPage/UserAccountPhoneModification/UserAccountPhoneModification')
                },
                // 修改密码
                {
                    path: 'account/password',
                    name: 'passwordAccount@user',
                    meta: { hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/UserPage/UserAccountPassword/UserAccountPassword')
                }
            ]
        },
        {
            path: '/resource',
            component: () =>
                import('@/views/index/views/MyResource/MyResource'),
            children: [
                {
                    path: '',
                    redirect: 'courseware/list'
                },
                // 我的资源 -> 个人上传
                {
                    path: 'courseware/list',
                    name: 'coursewareList@resource',
                    meta: { hideSidebar: true, hideResourceSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyResource/ResourceLibrary/ResourceLibrary')
                },
                // 我的资源 -> 我的题目
                {
                    path: 'courseware/mycollection',
                    name: 'courseMyCollection@resource',
                    meta: { hideSidebar: true, hideResourceSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyResource/MyCollection/MyCollection')
                },
                // 我的资源 -> 我的在线讲义
                {
                    path: 'courseware/myhandout',
                    name: 'courseMyHandout@resource',
                    meta: { hideSidebar: true, hideResourceSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyResource/MyOnlineHandout/MyOnlineHandout')
                },
                // 我的资源 -> 共享在线讲义
                {
                    path: 'courseware/sharehandout',
                    name: 'courseShareHandout@resource',
                    meta: { hideSidebar: true, hideResourceSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyResource/ShareOnlineHandout/ShareOnlineHandout')
                },
                // 我的资源 -> 样板课
                {
                    path: 'courseware/templateLesson',
                    name: 'templateLesson@resource',
                    meta: { hideSidebar: true, hideResourceSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyResource/TemplateLesson/TemplateLesson')
                }
            ]
        },
        // 学习中心
        {
            path: '/learning',
            component: () =>
                import('@/views/index/views/LearningCenterPage/LearningCenterPage'),
            children: [
                {
                    path: '',
                    redirect: 'learning/list'
                },
                {
                    path: 'learningcenter/list',
                    name: 'LearningcenterList@learning',
                    meta: { hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/LearningCenterPage/LearningCenterList/LearningCenterList')
                },
                // 视频跳转
                {
                    path: 'learningcenter/video',
                    name: 'LearningcenterList@video',
                    // meta: { name: '视频跳转', isFullScreen: true },
                    meta: { hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/LearningCenterPage/LearningVideoBack/LearningVideoBack')
                }
            ]
        },
        // 教学规划
        {
            path: '/teachingPlan',
            name: 'teachingPlan@teachingPlan',
            meta: { name: '教学规划', hideSidebar: true },
            component: () => import('@/views/index/views/TeachingPlan/TeachingPlan')
        },
        // 下载
        {
            path: '/download',
            name: 'download',
            meta: { name: '下载', hideSidebar: true, isFullScreen: true },
            component: () =>
                import('@/views/index/views/SoftwareDownload/SoftwareDownload')
        },
        {
            path: '/businessMark',
            name: 'businessMark',
            meta: { name: '对业务服务评价', hideSidebar: true },
            component: () => import('@/views/index/views/BusinessMark/BusinessMark')
        },
        {
            path: '/businessComment',
            name: 'businessComment',
            meta: { name: '查看业务评价', hideSidebar: true },
            component: () => import('@/views/index/views/BusinessComment/BusinessComment')
        },
        // 我的团队
        {
            path: '/myTeam',
            component: () =>
                import('@/views/index/views/MyTeamPage/MyTeamPage'),
            children: [
                {
                    path: '',
                    name: 'myTeam',
                    meta: { name: '我的团队', hideSidebar: true, hideMemberSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyTeamPage/MyTeam/MyTeam')
                },
                {
                    path: 'member/basic',
                    name: 'basicInfo@myTeam',
                    meta: { name: '我的团队成员', hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyTeamPage/TeamMemberBasicInfo/TeamMemberBasicInfo')
                },
                {
                    path: 'member/student',
                    name: 'studentInfo@myTeam',
                    meta: { name: '我的团队成员', hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyTeamPage/TeamMemberStudentInfo/TeamMemberStudentInfo')
                },
                {
                    path: 'member/census',
                    name: 'censusInfo@myTeam',
                    meta: { name: '我的团队成员', hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyTeamPage//TeamMemberCensusInfo/TeamMemberCensusInfo')
                }
            ]
        },
        {
            path: '/myStudent',
            component: () =>
                import('@/views/index/views/MyStudentPage/MyStudentPage'),
            children: [
                {
                    path: 'tutorshipDetail',
                    name: 'tutorShip@myStudent',
                    meta: { name: '辅导详情', hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyStudentPage/MyStudentTutorshipDetail/MyStudentTutorshipDetail')
                },
                {
                    path: 'coursePlanning',
                    name: 'coursePlanning@myStudent',
                    meta: { name: '课程规划', hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyStudentPage/MyStudentCoursePlanning/MyStudentCoursePlanning')
                },
                {
                    path: 'auditionCoursePlan',
                    name: 'auditionCoursePlan@myStudent',
                    meta: { name: '试听课程规划', hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyStudentPage/MyStudentAuditionCoursePlan/MyStudentAuditionCoursePlan')
                },
                {
                    path: 'examAnalysic',
                    name: 'examAnalysic@myStudent',
                    meta: { name: '考试分析', hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyStudentPage/MyStudentExamAnalysic/MyStudentExamAnalysic')
                },
                // {
                //     path: 'schoolexamPaper',
                //     name: 'schoolexamPaper@myStudent',
                //     meta: { name: '学校试卷', hideSidebar: true },
                //     component: () =>
                //         import('@/views/index/views/MyStudentPage/MyStudentSchoolExamPaper/MyStudentSchoolExamPaper')
                // },
                {
                    path: 'schoolExamineAnalysic',
                    name: 'schoolExamineAnalysic@myStudent',
                    meta: { name: '学校考情分析', hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyStudentPage/schoolExamineAnalysic/schoolExamineAnalysic')
                },
                {
                    path: 'localExamine/:tabIndex',
                    name: 'localExamine@myStudent',
                    meta: { name: '当地考情', hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyStudentPage/MyStudentLocalExamine/MyStudentLocalExamine')
                },
                {
                    path: 'newPolicy',
                    name: 'newPolicy@myStudent',
                    meta: { name: '最新政策分析', hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyStudentPage/MyStudentLocalExamine/src/NewPolicyAnalysic')
                },
                {
                    path: 'teachingProgress',
                    name: 'teachingProgress@myStudent',
                    meta: { name: '当地教学进展', hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyStudentPage/MyStudentTeachingProgress/MyStudentTeachingProgress')
                },
                {
                    path: 'examineCheckPaper',
                    name: 'examineCheckPaper@myStudent',
                    meta: { name: '查看试卷', hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyStudentPage/src/MyStudentCheckPaper')
                },
                {
                    path: 'checkPaper',
                    name: 'checkPaper@myStudent',
                    meta: { name: '查看试卷', hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyStudentPage/src/MyStudentCheckPaper')
                },
                {
                    path: 'blockPage',
                    name: 'blockPage@myStudent',
                    meta: { name: '空白页', hideSidebar: true },
                    component: () =>
                        import('@/views/index/views/MyStudentPage/MyStudentBlackPage/MyStudentBlackPage')
                }
            ]
        },
        {
            path: '/schoolExamDetailPage',
            name: 'schoolExamDetailPage@myStudent',
            meta: { name: '试卷信息', hideSidebar: true },
            component: () =>
                import('@/views/index/views/SchoolExamDetailPage/SchoolExamDetailPage')
        },
        //  作业预览页面
        {
            path: '/previewHomework',
            name: 'previewHomework@homework',
            meta: { name: '预览作业题目', hideSidebar: true },
            component: () =>
                import('@/views/index/views/HomeworkQuestionPreview/HomeworkQuestionPreview')
        },

        // 我的课程-布置作业 -- 添加题目
        {
            path: '/add-homework',
            name: 'addHomework@homework',
            meta: { name: '添加题目', hideSidebar: true },
            component: () =>
                import('@/views/index/views/AddHomeworkPage/AddHomeworkPage')
        },
        // 作业中心
        {
            path: '/homework',
            name: 'homework@course',
            meta: { name: '作业中心', hideSidebar: false },
            component: () =>
                import('@/views/index/views/Homework/Homework')
        },
        // 作业中心-批改作业
        {
            path: '/homework/correct',
            name: 'correct@course',
            meta: { name: '批改作业', hideSidebar: true },
            component: () =>
                import('@/views/index/views/HomeworkCorrect/HomeworkCorrect')
        },
        // 作业中心-作业报告
        {
            path: '/homework/report',
            name: 'report@course',
            meta: { name: '作业报告' },
            component: () =>
                import('@/views/index/views/HomeworkReport/HomeworkReport')
        },
        // 查看答题卡
        {
            path: '/checkSheet',
            name: 'check@sheet',
            meta: { name: '查看答题卡', hideSidebar: true },
            component: () =>
                import('@/views/index/views/CheckSheet/CheckSheet')
        },
        // 我的课程-辅导详情-辅导上课报告
        {
            path: '/student',
            component: () =>
                import('@/views/index/views/MyStudentTutorReportPage/MyStudentTutorReportPage'),
            children: [{
                path: 'tutorship/report',
                name: 'tutorReport@student',
                meta: { name: '辅导上课报告', isFullScreen: true },
                component: () =>
                    import('@/views/index/views/MyStudentTutorReportPage/MyStudentTutorReportList/MyStudentTutorReportList')
            }]
        },
        // 历史课程 - 查看回放
        {
            path: '/historyVideo',
            component: () =>
                import('@/views/index/views/HistoryRecordVideoPage/HistoryRecordVideoPage'),
            children: [{
                path: 'videoReplay',
                name: 'videoReplay@History',
                meta: { isFullScreen: true },
                component: () =>
                    import('@/views/index/views/VideoView/VideoView')
            }]
        },
        {
            path: '/teamVideo',
            component: () =>
                import('@/views/index/views/MyTeamVideoReplayPage/MyTeamVideoReplayPage'),
            children: [{
                path: 'videoReplay',
                name: 'videoReplay@Team',
                meta: { name: '回放点评', isFullScreen: true },
                component: () =>
                    // 我的团队-课程回放点评(v3.0 重构)
                    import('@/views/index/views/MyTeamVideoReplayPage/VideoComment/VideoComment')
            }]
        },
        // 测评题目预览页面
        {
            path: '/previewEvaluation',
            name: 'preview@evaluation',
            meta: { name: '测评题目', hideSidebar: true },
            component: () =>
                import('@/views/index/views/EvaluationQuestionPreview/EvaluationQuestionPreview')
        },
        // 胶囊测评推送页面
        {
            path: '/previewEvaluation/capsule',
            name: 'previewEvaluation@capsule',
            meta: { name: '推送测评', hideSidebar: true },
            component: () =>
                import('@/views/index/views/EvaluationQuestionsPush/EvaluationQuestionsPush')
        },
        // 试卷测评推送页面
        {
            path: '/previewEvaluation/paper',
            name: 'previewEvaluation@paper',
            meta: { name: '推送冲刺卷', hideSidebar: true },
            component: () =>
                import('@/views/index/views/EvaluationQuestionsPushTest/EvaluationQuestionsPushTest')
        },
        // 测评题目批改页面
        {
            path: '/correntEvaluation',
            name: 'correct@evaluation',
            meta: { name: '批改测评', hideSidebar: true },
            component: () =>
                import('@/views/index/views/EvaluationQuestionCorrect/EvaluationQuestionCorrect')
        },
        // 添加测评题目页面
        {
            path: '/addEvaluation',
            name: 'addEvaluation@evaluation',
            meta: { name: '增加测评题目', hideSidebar: true },
            component: () =>
                import('@/views/index/views/AddEvaluationPage/AddEvaluationPage')
        },
        // 测评报告
        {
            path: '/evaluationReport',
            name: 'report@evaluation',
            meta: { name: '测评报告' },
            component: () =>
                import('@/views/index/views/EvaluationReport/EvaluationReport')
        },
        // 我的课程-课程历史-课程日志(v2.10重构)
        {
            path: '/knowledgesMastery',
            name: 'history@courseKnowledgeMastery',
            meta: { name: '知识点掌握', hideSidebar: true },
            component: () =>
                import('@/views/index/views/KnowledgesMastery/index')
        },
        // 预览知识点资源
        {
            path: '/preview-resource',
            name: 'PreviewResource',
            meta: {name: '预览资源', hideSidebar: true},
            component: () => import('@/views/index/views/PreviewResource/PreviewResource')
        },
        // 预览课程资源
        {
            path: '/lesson-resource',
            name: 'LessonResource',
            meta: {name: '预览资源', hideSidebar: true},
            component: () => import('@/views/index/views/LessonResource/LessonResource')
        },
        // 试听课反馈
        {
            path: '/demoClassFeedback',
            name: 'demoClass@feedback',
            meta: { name: '试听课反馈', hideSidebar: true },
            component: () =>
                import('@/views/index/views/DemoClassFeedback/DemoClassFeedback')
        },
        // 课件预览
        {
            path: '/CoursePreview',
            name: 'course@preview',
            meta: { name: '课件预览', hideSidebar: true },
            component: () =>
                import('@/views/index/views/CoursePreview/CoursePreview')
        },
        // 试听课程规划
        {
            path: '/auditionCoursePlan',
            name: 'audition@coursePlan',
            meta: { name: '试听课程规划', hideSidebar: true },
            component: () =>
                import('@/views/index/views/AuditionCoursePlan/AuditionCoursePlan')
        },
        {
            path: '/alreadyLearnPlan',
            name: 'already@learnPlann',
            meta: { name: '已学规划课程', hideSidebar: true },
            component: () =>
                import('@/views/index/views/alreadyLearnPlan/alreadyLearnPlan')
        },
        // 版本信息
        {
            path: '/auditionCoursePlan/versionInformation',
            name: 'audition@versionInformation',
            meta: { name: '版本信息', hideSidebar: true },
            component: () =>
                import('@/views/index/views/AuditionCoursePlan/VersionInfo')
        },
        // 消息中心 - 首页
        {
            path: '/centerMessage',
            name: 'messageCenter',
            meta: { name: '消息中心', hideSidebar: true, hideMessagePopup: true },
            component: () => import('@/views/index/views/MessageCenter/MessageCenter')
        },
        // 消息中心 - 消息详情
        {
            path: '/centerMessage/details/:id?',
            name: 'messageCenter@details',
            meta: { name: '消息中心', hideSidebar: true, hideMessagePopup: true },
            component: () => import('@/views/index/views/MessageDetails/MessageDetails')
        },
        // 404 放在最后
        {
            path: '*',
            name: 'notFound',
            meta: { name: '404' },
            component: () =>
                import('@/views/index/views/NotFound/NotFound')
        },
        // 考试指南
        {
            path: '/examGuide',
            name: 'examGuide',
            meta: { name: '考试指南', hideSidebar: true },
            component: () => import('@/views/index/views/ExamGuide/ExamGuide')
        }
    ]
});
router.beforeEach((to, from, next) => {
    if (to.meta.name) {
        document.title = '好分数辅导教师中心-' + to.meta.name;
    } else {
        document.title = '好分数辅导教师中心';
    }
    next();
});

export default router;



// WEBPACK FOOTER //
// ./src/views/index/router/index.js